/** www.google.com → https://www.google.com برای ذخیره و validation */
export function normalizeExternalUrl(raw) {
	const trimmed = (raw ?? "").trim();
	if (!trimmed) return "";
	if (/^https?:\/\//i.test(trimmed)) return trimmed;
	if (trimmed.startsWith("//")) return `https:${trimmed}`;
	return `https://${trimmed}`;
}

export function isValidExternalUrl(raw) {
	const normalized = normalizeExternalUrl(raw);
	if (!normalized) return false;
	try {
		const u = new URL(normalized);
		return u.protocol === "http:" || u.protocol === "https:";
	} catch {
		return false;
	}
}
